export default __webpack_public_path__ + "static/media/squate.9ebbd071.png";